
	import { Observer } from 'mobx-vue';
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import Modal from '@/components/Modal.vue';

	export interface HelpModalProp {
		title?: string;
		display: string;
		imgPath: string;
		description: string;
	}

	@Observer
	@Component({ components: { Modal } })
	export default class NewHelpModal extends Vue {
		@Prop({ required: true }) prop!: HelpModalProp;
		@Prop({ required: false, default: false }) infoOnly!: boolean;
		@Prop({ required: false, default: 'row' }) variant!: 'row' | 'column';
		prescriptionCopy: any;

		mounted() {
			this.prescriptionCopy = JSON.parse(JSON.stringify(this.$state.prescription.newPrescription));
		}

		close() {
			this.$emit('close');
			this.$state.prescription.newPrescription = this.prescriptionCopy;
			this.$state.prescription.allowUpdate = true;
		}

		save() {
			this.$emit('close');
			this.$state.prescription.allowUpdate = true;
		}
	}
